import { faListUl } from '@fortawesome/pro-regular-svg-icons'
import { ViewValueWithTruncate, useAccountId } from '@labrav/common'
import { useParams } from 'react-router-dom'

import { SectionWrapper } from '../../../../common/components/SectionWrapper/SectionWrapper'
import {
  DetailInfo,
  DetailRow,
} from '../../../../common/components/DetailRow/DetailRow'
import { TruncateWithLink } from '../../../../common/components/TruncateWithLink/TruncateWithLink'
import { useSelector } from '../../../../store'
import { useStyles } from '../RenewChannelOfferSubscription.styles'

export const OfferSubscriptionDetail = ({
  resellerAuthId,
}: {
  resellerAuthId?: string
}) => {
  const { classes } = useStyles()
  const {
    cloud: routeCloud,
    accountId: routeAccountId,
    subscriptionId,
  } = useParams<{
    cloud: string
    accountId: string
    subscriptionId?: string
  }>()
  const fallbackAccountId = useAccountId({ product: 'flyout' }) || ''
  const accountId = routeAccountId || fallbackAccountId
  const subscriptionDetail = useSelector(
    state =>
      state?.subscriptions?.currentSubscription?.[subscriptionId!]
        ?.cppoDetails || null
  )

  const getLabraCPPODetailPageUrl = (cppoId?: string) => {
    if (cppoId) {
      return `${window.location.origin}/flyout/${routeCloud}/${accountId}/authorization/${resellerAuthId}/channel-offers/${cppoId}/detail`
    }
    return ''
  }

  return (
    <SectionWrapper
      heading="Contract details"
      icon={faListUl}
      children={
        <div className={classes.section}>
          <DetailRow
            borderBottom
            children={
              <DetailInfo
                gridSize={12}
                title={'Contract ID'}
                value={
                  <ViewValueWithTruncate
                    value={subscriptionId || '-'}
                    showIcon={!!subscriptionId}
                  />
                }
                keyName={'privateOfferId'}
              />
            }
          />

          <DetailRow
            borderBottom
            children={
              <DetailInfo
                gridSize={12}
                title={'Offer name'}
                value={
                  subscriptionDetail?.offerName ? (
                    <TruncateWithLink
                      text={subscriptionDetail?.offerName}
                      link={getLabraCPPODetailPageUrl(
                        subscriptionDetail?.offerName
                      )}
                    />
                  ) : (
                    '-'
                  )
                }
                keyName={'offerName'}
              />
            }
          />

          <DetailRow
            borderBottom
            children={
              <DetailInfo
                gridSize={12}
                title={'AWS offer ID'}
                value={
                  <ViewValueWithTruncate
                    value={subscriptionDetail?.cloudOfferId}
                    showIcon={true}
                  />
                }
                keyName={'awsAgreementId'}
              />
            }
          />
          <DetailRow
            children={
              <DetailInfo
                gridSize={12}
                title={'Offer type'}
                value={'Channel offer'}
                keyName={'offerType'}
              />
            }
          />
        </div>
      }
    />
  )
}
